import { render } from "./mainLayout.vue?vue&type=template&id=718dd09d&scoped=true"
import script from "./mainLayout.vue?vue&type=script&lang=js"
export * from "./mainLayout.vue?vue&type=script&lang=js"

import "./mainLayout.vue?vue&type=style&index=0&id=718dd09d&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718dd09d"]])

export default __exports__